import * as React from 'react'
import Link from 'next/link'
import Router from 'next/router'
import FixNavModal from 'New/side-nav/fix-nav'
import ProtalModal from 'New/side-nav/components/protal-modal'
import getLocation, {
  setLocation2storage,
  setSelectedCity2storage,
  sendTeaLocationEvent,
} from 'lib/get-location'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { GlobalStoreContext } from 'Components/store'
import PubSub from 'pubsub-js'
import City from './new-city'
import Search from './new-search'
import User from './new-user'
import HeaderSwitch from './new-header-switch'
import TopTips from './top-tops-dynamic'
import useHasTips from 'Components/hooks/use-top-tips'
import useFireFox from 'Components/hooks/use-firefox'
import classNames from 'classnames'

const live_yellow = require('static/live-yellow.gif')

function Header({
  pageType = 'new',
  cusHeadType = '',
}: {
  pageType?: string
  cusHeadType?: string
}) {
  const isHasTips = useHasTips()
  const isFireFox = useFireFox()
  // 当前激活的tab
  const [active, updateActive] = React.useState<string>()
  const [showCity, setCityPopup] = React.useState(false)
  // 防止ssr与前端渲染的html不一致的问题，在服务端不渲染城市
  const { state, dispatch } = React.useContext(GlobalStoreContext)
  const { cityName } = state

  const [hideSearch, setSearch] = React.useState(false)
  const asPath = (Router && Router.router && Router.router.asPath) || ''
  React.useEffect(() => {
    const pathname = asPath.split('?')[0]
    updateActive(pathname)
    setSearch(false)
  }, [asPath])
  React.useEffect(() => {
    if (typeof state.cityName === 'undefined') {
      try {
        const cityName = window.localStorage.getItem('cityName')
        // 优先从本地存储中获取城市
        if (cityName) {
          dispatch({
            type: 'setCityName',
            payload: cityName || '',
          })
          sendTeaLocationEvent('init_top_location')
        } else {
          // 获取不到时，调用location获取
          getLocation().then((location) => {
            setLocation2storage(location)
            dispatch({
              type: 'setCityName',
              payload: location.cityName || '',
            })
            sendTeaLocationEvent('init_top_location')
          })
        }
      } catch (err) {}
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.cityName])

  const [handleType, setHandleType] = React.useState('')
  const handler = React.useCallback((type, value) => {
    setHandleType(value)
  }, [])

  // 可自定义header className 目前支持 black 影院模式
  const [cusType, setCusType] = React.useState(cusHeadType)
  const typeHandler = React.useCallback((type, value) => {
    setCusType(value)
  }, [])

  const routeChangeComplete = React.useCallback(() => {
    PubSub.publish('CUS_HEAD_TYPE', '')
  }, [])

  React.useEffect(() => {
    const token = PubSub.subscribe('SIDE_NAV_STATUS', handler)
    const typeToken = PubSub.subscribe('CUS_HEAD_TYPE', typeHandler)
    Router.events.on('routeChangeComplete', routeChangeComplete)
    return () => {
      PubSub.unsubscribe(token)
      PubSub.unsubscribe(typeToken)
      Router.events.off('routeChangeComplete', routeChangeComplete)
    }
  }, [])

  // 切换搜索框显示隐藏 带过渡效果
  const [isEnter, setIsEnter] = React.useState(false)
  const [isLeave, setIsLeave] = React.useState(false)
  const isLeaveRef = React.useRef(false)
  const inputHandler = React.useCallback(
    (type, value) => {
      if (value) {
        setIsLeave(true)
        isLeaveRef.current = true
      } else {
        if (hideSearch !== value) {
          setIsEnter(true)
        }
        isLeaveRef.current = false
        setSearch(false)
      }
    },
    [hideSearch]
  )

  const handleAnimationEnd = React.useCallback(() => {
    if (isEnter) {
      setIsEnter(false)
    }
    if (isLeave) {
      setIsLeave(false)
    }
    if (isLeaveRef.current) {
      isLeaveRef.current = false
      setSearch(true)
    }
  }, [isEnter, isLeave])

  React.useEffect(() => {
    const inputToken = PubSub.subscribe('SEARCH_INPUT_Hidden', inputHandler)
    return () => {
      PubSub.unsubscribe(inputToken)
    }
  }, [inputHandler])

  return (
    <header className="header">
      <div
        className={`header-fix sm:tw-w-full tw-w-1024 sm:tw-left-1/2 tw-left-512 header-content search-row clearfix ${cusType}`}
      >
        <div className={`left-section ${handleType}`}>
          <HeaderSwitch pageType={pageType} />
          <Link href="/home" as="/">
            <a
              target="_blank"
              className="fl logo"
              title="懂车帝"
              onClick={() => {
                sendTeaCommEvent('clk_event', {
                  event_id: 'dcar_brand_icon',
                })
              }}
            />
          </Link>
          <div
            className="city tw-ml-24 lg:tw-ml-40"
            onMouseEnter={(event) => {
              event.stopPropagation()
              event.nativeEvent.stopImmediatePropagation()
              sendTeaCommEvent('hover_event', {
                event_id: 'common_city_select_btn',
                shrink_type: 'unfold',
              })
              setCityPopup(true)
            }}
            onMouseLeave={(event) => {
              event.stopPropagation()
              event.nativeEvent.stopImmediatePropagation()
              setCityPopup(false)
              sendTeaCommEvent('hover_event', {
                event_id: 'common_city_select_btn',
                shrink_type: 'fold',
              })
            }}
            onClick={(event) => {
              event.stopPropagation()
            }}
          >
            {cityName}
            {showCity && (
              <City
                onChange={(name) => {
                  setSelectedCity2storage(name!)
                  sendTeaLocationEvent('switch_top_location', name)
                  setCityPopup(false)
                }}
              />
            )}
            <span className="icon-arrow-ic-r arrow-down" />
          </div>
        </div>
        <div
          onAnimationEnd={handleAnimationEnd}
          className={classNames(
            'wrapper tw-w-354 md:tw-w-378 lg:tw-w-574 xl:tw-w-569 2xl:tw-w-664',
            {
              'wrapper-leave': isLeave,
              'wrapper-enter': isEnter,
            }
          )}
        >
          {!hideSearch && <Search />}
        </div>
        <div className="right-section tw-right-32 md:tw-right-53 lg:tw-right-59 xl:tw-right-64 2xl:tw-right-72">
          <User className="small" />
          <a
            className="dcdmp tw-pl-24 lg:tw-pl-40"
            target="_blank"
            rel="nofollow"
            href="https://mp.dcdapp.com/?link_source=pc"
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'common_top_btn',
              })
            }}
          >
            <span className="dcdmp-icon" />
            懂车号
          </a>
          <a
            target="_blank"
            rel="nofollow"
            href="https://www.dcdapp.com/download/"
            className="download"
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'common_top_btn',
              })
            }}
            onMouseEnter={(event) => {
              sendTeaCommEvent('hover_event', {
                event_id: 'common_download_app_btn',
                button_name: '下载App',
              })
            }}
          >
            <span className="code-icon" />
            <span className="code-name">下载App</span>
            <div className="vrcode-container">
              <h3>扫码下载懂车帝App</h3>
              <img
                src={require('static/dcd-code@3x.png')}
                alt="懂车帝app"
                className="vrcode"
              />
            </div>
          </a>
        </div>
      </div>
      <FixNavModal pageType={pageType} />
      {isHasTips ? <TopTips /> : ''}
      <style jsx>
        {`
          .header {
            color: #1f2129;
            font-size: 18px;
            position: relative;
            height: ${isHasTips ? '136px' : '84px'};
          }
          .header-content {
            padding-top: 20px;
            height: 84px;
          }
          .header-fix {
            position: fixed;
            -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
            background-color: ${isFireFox
      ? 'rgba(255, 255, 255, 1)'
      : 'rgba(255, 255, 255, 0.9)'};
            transform: translateX(-50%);
            max-width: 1920px;
            min-width: 1024px;
            top: ${isHasTips ? '52px' : '0'};
            z-index: 9999;
          }
          .left-section {
            position: absolute;
          }
          .left-section {
            left: 28px;
          }
          .right-section {
            position: absolute;
            top: 25px;
          }
          .wrapper {
            margin: 0 auto;
            min-width: 354px;
          }

          .wrapper-leave {
            animation: leave 0.2s ease;
          }
          @keyframes leave {
            from {
              opacity: 1;
            }
            to {
              opacity: 0;
            }
          }

          .wrapper-enter {
            animation: enter 0.2s ease;
          }
          @keyframes enter {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }

          .logo {
            width: 141px;
            height: 46px;
            background: url(${require('static/new-logo-3.png')}) no-repeat 0 0 /
              cover;
          }
          .search-row {
            line-height: 36px;
            font-size: 14px;
          }
          .nav-row {
            background: #1f2129;
            height: 48px;
            line-height: 48px;
            border-radius: 4px;
            background-image: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0.6),
              rgba(0, 0, 0, 0)
            );
          }
          .nav {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            margin-left: 56px;
            color: #fff;
            transition: all 0.1s ease-in-out;
            position: relative;
          }
          .hasicon {
            margin-left: 80px;
          }
          .nav:first-child {
            margin-left: 40px;
          }
          .nav:hover {
            color: #ffcd32;
          }
          .nav:hover .nav-icon {
            content: url('${live_yellow}');
          }
          .nav:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 4px;
            background: transparent;
          }
          .active {
            color: #ffcd32;
          }
          .active .nav-icon {
            content: url('${live_yellow}');
          }
          .nav.active:after {
            background: #ffcd32;
          }
          .nav-icon {
            position: absolute;
            left: -24px;
            width: 24px;
            height: 24px;
            display: inline-block;
            object-fit: cover;
            object-position: center;
          }
          .city {
            position: relative;
            float: right;
            font-size: 14px;
            cursor: pointer;
            user-select: none;
            padding: 6px 20px 10px 0;
          }
          .city:hover {
            color: #e62021;
          }
          .city::before:hover {
            color: #e62021;
          }
          .city:hover .arrow-down {
            color: #e62021;
          }
          .arrow-down {
            display: inline-block;
            font-size: 14px;
            color: #1f2129;
            margin-left: 8px;
            margin-top: -3px;
            transform: rotate(90deg);
            vertical-align: middle;
          }
          :global(.header .city > section) {
            left: 0;
          }
          .dcdmp {
            float: right;
            font-size: 12px;
            padding-top: 10px;
          }
          .download {
            position: relative;
            float: right;
            font-size: 12px;
            text-align: center;
            padding-top: 10px;
          }
          .download:hover .vrcode-container {
            display: block;
          }

          .code-icon {
            position: absolute;
            width: 16px;
            height: 16px;
            background-image: url(${require('static/code-icon-bg.png')});
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100%;
            vertical-align: -2px;
            margin-left: 14px;
            margin-top: -8px;
          }
          .download:hover .code-icon {
            background-image: url(${require('static/code-icon-bg-active.png')});
            background-position: center;
            background-repeat: no-repeat;
          }
          .dcdmp:hover .dcdmp-icon {
            background-image: url(${require('static/dcdm-bg-active.png')});
            background-position: center;
            background-repeat: no-repeat;
          }
          .dcdmp-icon {
            position: absolute;
            width: 16px;
            height: 16px;
            background-image: url(${require('static/dcdm-bg.png')});
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100%;
            vertical-align: -2px;
            margin-left: 9px;
            margin-top: -8px;
          }
          .vrcode-container {
            display: none;
            position: absolute;
            top: 52px;
            left: 0px;
            width: 200px;
            height: 236px;
            z-index: 2000;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
            text-align: center;
            background-color: #ffffff;
          }
          .vrcode {
            width: 160px;
            height: 160px;
            margin: 20px;
          }
          h3 {
            font-size: 14px;
            color: #1f2129;
            font-weight: normal;
            margin-top: 16px;
            line-height: 20px;
          }
          .right {
            margin-right: 0;
          }
          :global(div > .small) {
            font-size: 14px !important;
          }

          .theater {
            background: #1f2129;
            color: #979aa8;
          }
          :global(.header-fix.theater .arrow-down) {
            color: #979aa8;
          }
          :global(.header-fix.theater .search) {
            background: #1f2129;
            border: solid 2px rgba(255, 255, 255, 0.08);
          }
          :global(.header-fix.theater .search-form) {
            background-color: rgba(255, 255, 255, 0.08);
          }
          :global(.header-fix.theater .search-btn, .header-fix.theater
              .login-btn) {
            font-size: 14px;
            font-weight: 500;
            color: #1f2129;
          }
          :global(.header-fix.theater .download:hover, .header-fix.theater
              .dcdmp:hover, .header-fix.theater .city:hover, .header-fix.theater
              .city:hover
              .arrow-down) {
            color: #fff;
          }
          :global(.header-fix.theater .code-icon) {
            background-image: url(${require('static/black-code-icon.png')});
          }
          :global(.header-fix.theater .download:hover .code-icon) {
            background-image: url(${require('static/hover-black-code-icon.png')});
          }
          :global(.header-fix.theater .logo) {
            background: url(${require('static/black-logo.png')}) no-repeat 0 0 /
              cover;
          }
          :global(.header-fix.theater .dcdmp-icon) {
            background-image: url(${require('static/black-dcdm.png')});
          }
          :global(.header-fix.theater .dcdmp:hover .dcdmp-icon) {
            background-image: url(${require('static/hover-black-dcdm.png')});
          }
          :global(.header-fix.theater .side-nav-switch) {
            background: url(${require('static/black-icon-switch-btn.png')})
              no-repeat 0 0 / cover;
          }
          :global(.header-fix.theater .arrow) {
            border-bottom: 4px solid #fff;
          }
        `}
      </style>
    </header>
  )
}

export default Header
